// extracted by mini-css-extract-plugin
export default {"tableContainer":"Reports_tableContainer__qPmNp","tableHeader":"Reports_tableHeader__Q5enG","tableRow":"Reports_tableRow__Bb+oU"};